import Head from 'next/head';
import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import BlogDetail from 'components/Blog/BlogDetail';
import useTheme from 'hooks/useTheme';
import { Blogs } from 'constant/type';
import Axios from 'config/Axios';
import { useEffect } from 'react';

const BlogDetailPage: NextPage = ({
  blog,
  related,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  useTheme({
    light: true,
  });

  useEffect(() => {
    const wrapper = document.getElementById('__next');
    if (wrapper) wrapper.style.overflow = 'visible'; // allow sticky
  }, []);

  return (
    <>
      <Head>
        <title>{blog.title}</title>
        <meta name="description" content={blog.description} />
        <meta property="og:title" content={blog.title} key="title" />
        <meta property="og:image" content={blog.image?.url} key="image" />
        <meta property="og:type" content="article" />
        <meta property="og:description" content={blog.description} />
        <meta
          property="og:url"
          content={`https://spiritlabs.co/blog/${blog.slug}`}
        />
        <meta property="og:site_name" content="Spirit labs" />
      </Head>
      {blog && related && <BlogDetail blog={blog} relatedBlogs={related} />}
    </>
  );
};

export default BlogDetailPage;

export const getStaticPaths = async () => {
  try {
    const res = await Axios.get('/blogs');
    const paths = res.data.data.map((blog: Blogs) => ({
      params: { id: blog.attributes.slug !== null ? blog.attributes.slug : '' },
    }));

    return {
      paths,
      fallback: 'blocking',
    };
  } catch (err) {
    return {
      paths: [],
      fallback: 'blocking',
    };
  }
};

export const getStaticProps: GetStaticProps = async (context: any) => {
  try {
    const res = await Axios.get('/blogs/' + context.params.id);
    const all = res.data;

    const blog = res.data || [];
    const related =
      res.data.related
        ?.sort((blog1: any, blog2: any) =>
          blog1.published < blog2.published ? 1 : -1,
        )
        .filter((_: any, index: number) => index < 3) || []; // BO undefined

    if (!all) {
      return {
        props: { blog, related },
      };
    }

    return {
      props: { blog, related },
      revalidate: 30,
    };
  } catch (err) {
    return {
      notFound: true,
    };
  }
};
